import FJLocalStore from '../../../store/FJLocalStore';
import FJToolTip from '../FJToolTip/FJToolTip';
import DeleteIcon from '../../../assets/svg/delete.svg?react';
import EditIcon from '../../../assets/svg/edit-1.svg?react';
import ShareSmallIcon from '../../../assets/svg/share-small.svg?react';
import ComparisonIcon from '../../../assets/svg/comparison.svg?react';

import styles from './FJImageItemIconBox.module.less';
import classNames from 'classnames';
import FJMessageStore from '../../../store/FJMessageStore';
import FJUtil from '../../../util/FJUtil';
import { useCallback } from 'react';
import FJDropdownNew from '../FJDropDown/FJDropdownNew';
import { SHARE_LIST } from '../../../config/dataConfig/FJCommonDataConfig';

const FJImageItemIconBox = props => {
    const {
        isShowDeleteIcon,
        isShowComparison,

        imageLoadingError = false,
        disabledComparison = false,
        isComparisonActive = false,
        isShowEditIcon = false,
        isShowShareIcon = true,

        onDelete,
        shareToSociety,
        changeComparison,
        onEdit,
        reLoadImage,
    } = props;

    const _onMouseUp = useCallback(() => {
        changeComparison && changeComparison(false);
        FJUtil.removeEvent(window, 'mouseup', _onMouseUp);
    }, [changeComparison]);

    const _onMouseDown = useCallback(
        e => {
            if (imageLoadingError) {
                FJMessageStore.addMessage(FJLocalStore._('failed-to-preview-please-try-again'), 'error');
                reLoadImage && reLoadImage(e);
                return;
            }
            if (disabledComparison) return;

            changeComparison && changeComparison(true);
            FJUtil.addEvent(window, 'mouseup', _onMouseUp);

            return () => {
                FJUtil.removeEvent(window, 'mouseup', _onMouseUp);
            };
        },
        [imageLoadingError, reLoadImage, disabledComparison, changeComparison, _onMouseUp],
    );

    const _renderShareTrigger = ({ ref, active, onClick }) => {
        return (
            <FJToolTip title={'share'}>
                <div className={styles.hover_box} ref={ref} onClick={onClick}>
                    <ShareSmallIcon />
                </div>
            </FJToolTip>
        );
    };
    const _renderShareOverlay = ({ ref }) => {
        return (
            <div className={styles.share_box} ref={ref}>
                <div className={styles.share_title}>{FJLocalStore._('share')}</div>
                <div className={styles.share_content}>
                    {SHARE_LIST.map(item => (
                        <div
                            key={item.type}
                            className={styles.share_img_box}
                            onClick={() => {
                                shareToSociety && shareToSociety(item.type);
                            }}
                        >
                            {<item.icon />}
                        </div>
                    ))}
                </div>
            </div>
        );
    };
    return (
        <div className={styles.box}>
            {isShowDeleteIcon && (
                <FJToolTip title={'delete'}>
                    <div className={styles.hover_box} onClick={onDelete}>
                        <DeleteIcon />
                    </div>
                </FJToolTip>
            )}

            {isShowShareIcon && (
                <FJDropdownNew
                    renderTrigger={_renderShareTrigger}
                    renderOverlay={_renderShareOverlay}
                    isTopLayer={true}
                    placement='bottomCenter'
                    overlayClassName={styles.overlay}
                    trigger='click'
                />
            )}

            {isShowComparison && (
                <FJToolTip title={'compare'}>
                    <div
                        className={classNames(styles.hover_box, isComparisonActive ? styles.active : '')}
                        onMouseDown={_onMouseDown}
                    >
                        <ComparisonIcon />
                    </div>
                </FJToolTip>
            )}

            {isShowEditIcon && (
                <FJToolTip title={'re-edit'}>
                    <div className={styles.hover_box} onClick={onEdit}>
                        <EditIcon />
                    </div>
                </FJToolTip>
            )}
        </div>
    );
};
export default FJImageItemIconBox;
